import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { colors, fontFamily, breakpoints, zIndex } from '../../ui/variables';

export const AddInstitutionStyle = styled.main`
  background-color: ${colors.gray};
  box-sizing: border-box;
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone}px 0px 20px;
  width: 100%;

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone}px;
    }
  }

  .header-institution-registration {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 73px;
    margin-bottom: 35px;
    padding-right: 0;
    padding-left: 0;

    @media (min-width: 1300px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-right: 10%;
      padding-left: 5%;
    }

    .title-header {
      ${fontFamily.sourceSansPro.bold}
      font-size: 24px;
      margin-bottom: 10px;
      text-align: center;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        text-align: auto;
      }
      .number-of-registers {
        /* display: none; */
        /* @media (min-width: ${breakpoints.ipadLandscape.width}px) { */
        display: inline-block;
        ${fontFamily.sourceSansPro.regular}
        font-size: 14px;
        /* } */

        .score {
          ${fontFamily.sourceSansPro.bold}
          font-size: 14px;
          margin-left: 20px;
        }
      }
    }
  }

  .add-new-institution {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    width: 100%;
    color: ${colors.softBlue};

    .text {
      margin-left: 17px;
    }

    .plus-container {
      display: flex;
      justify-content: center;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: 2px solid ${colors.softBlue};
      svg {
        fill: ${colors.softBlue};
        height: 10px;
        width: 10px;
        align-self: center;
        justify-self: center;
      }
    }
  }

  .back-button-container {
    align-items: center;
    display: flex;
    left: 50px;
    position: relative;
    top: 35px;

    @media (min-width: ${breakpoints.hd.width}px) {
      top: 55px;
    }

    .back-link {
      svg {
        fill: ${colors.veryDarkGray};
        height: 16px;
        margin-right: 12px;
        width: 20px;
      }
    }
  }


`;
